import React, { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import { FaPhone } from "react-icons/fa";
import { IoMdPin } from "react-icons/io";
import { MdEmail } from "react-icons/md";
import CursosFooter from "../components/CursosFooter";
import HeaderPage from "../components/HeaderPage";
import Anuncio from "../components/Anuncio";
import Modal from "../components/Modals/Modal";
import { useAuth } from "../context/AuthContext";
import { useEventos } from "../context/EventosContext";
import { useFinanzas } from "../context/FinanzasContext"; //  Nuevo contexto para Finanzas

const DetallesPerfil = () => {
  const { user } = useAuth(); // Obtener información del usuario logueado
  const { eventos } = useEventos();
  const { pagos = [], fetchPagos } = useFinanzas(); //  Asegurar que `finanzas` tenga un valor por defecto

  // Estados para la paginación
  const [currentPage, setCurrentPage] = useState(1);
  const pagosPorPagina = 2; // Número de pagos por página

  // Estados para el modal de información
  const [modalData, setModalData] = useState({
    isOpen: false,
    title: "",
    content: "",
  });

  const handleShowModal = (title, content) => {
    setModalData({ isOpen: true, title, content });
  };

  const handleCloseModal = () => {
    setModalData({ isOpen: false, title: "", content: "" });
  };

  useEffect(() => {
    if (user?.rol_id === 3 && fetchPagos) {
      fetchPagos(); // Cargar solo los pagos del usuario logueado si la función existe
    }
  }, [user, fetchPagos]);

  // Lógica de paginación
  const indexOfLastPago = currentPage * pagosPorPagina;
  const indexOfFirstPago = indexOfLastPago - pagosPorPagina;
  const pagosActuales = pagos.slice(indexOfFirstPago, indexOfLastPago);
  const totalPaginas = Math.ceil(pagos.length / pagosPorPagina);

  return (
    <div className="flex min-h-screen bg-gray-100">
      {/* Sidebar */}
      <Sidebar />

      <main className="flex-1 md:p-6 p-4 overflow-x-hidden">
        <HeaderPage />

        <div className="flex flex-col lg:flex-row">
          {/*  Sección de Perfil */}
          <div className="bg-white w-full p-4 rounded-2xl shadow-md flex-1">
            {/* Fondo y perfil */}
            <div className="w-full bg-blue-900 h-40 relative flex items-center justify-start p-4 sm:pl-6 rounded-2xl">
              <div className="absolute w-28 h-28 bg-purple-300 rounded-full border-4 border-white -bottom-14 flex items-center justify-center">
                {user?.foto ? (
                  <img
                    src={user.foto}
                    alt=""
                    className="w-full h-full object-cover rounded-full"
                  />
                ) : (
                  <span className="text-4xl font-bold text-white flex items-center justify-center">
                    {user?.first_name?.charAt(0).toUpperCase() || "U"}
                  </span>
                )}
              </div>
            </div>

            {/* Información del usuario */}
            <div className="mt-16 pl-6">
              <h1 className="text-blue-900 text-2xl font-bold">
                {user?.first_name || "Usuario"}
              </h1>
              <p className="text-sm">
                {user?.rol_id === 1
                  ? "Rector"
                  : user?.rol_id === 2
                  ? "Profesor"
                  : "Estudiante" || "Rol desconocido"}
              </p>
            </div>

            {/* Información de contacto */}
            <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 sm:px-14 w-full">
              {/* Ubicación */}
              <div className="flex items-center rounded-lg p-4 bg-gray-50">
                <button
                  onClick={() => handleShowModal("Ubicación", "Neiva, Huila")}
                  className="min-w-[40px] min-h-[40px] bg-orange rounded-full flex items-center justify-center flex-shrink-0 hover:bg-orange-600 transition-colors cursor-pointer"
                >
                  <IoMdPin className="text-white text-xl" />
                </button>
                <p className="ml-4 text-blue-900 font-bold w-full break-words truncate">
                  Neiva, Huila
                </p>
              </div>

              {/* Teléfono */}
              <div className="flex items-center rounded-lg p-4 bg-gray-50">
                <button
                  onClick={() =>
                    handleShowModal(
                      "Teléfono",
                      user?.celular || "Sin teléfono"
                    )
                  }
                  className="min-w-[40px] min-h-[40px] bg-orange rounded-full flex items-center justify-center flex-shrink-0 hover:bg-orange-600 transition-colors cursor-pointer"
                >
                  <FaPhone className="text-white text-xl" />
                </button>
                <p className="ml-4 text-blue-900 font-bold w-full break-words truncate">
                  {user?.celular || "Sin teléfono"}
                </p>
              </div>

              {/* Correo */}
              <div className="flex items-center rounded-lg p-4 bg-gray-50">
                <button
                  onClick={() =>
                    handleShowModal(
                      "Correo Electrónico",
                      user?.correo || "Sin correo"
                    )
                  }
                  className="min-w-[40px] min-h-[40px] bg-orange rounded-full flex items-center justify-center flex-shrink-0 hover:bg-orange-600 transition-colors cursor-pointer"
                >
                  <MdEmail className="text-white text-xl" />
                </button>
                <p className="ml-4 text-blue-900 font-bold w-full break-words truncate">
                  {user?.correo || "Sin correo"}
                </p>
              </div>
            </div>

            {/* Sección "Acerca de" */}
            {user?.rol_id === 1 && (
              <div className="mt-8 px-2 md:px-6">
                <h2 className="text-base md:text-2xl font-bold text-blue-900 mb-4">
                  Acerca de
                </h2>
                <p className="text-gray leading-relaxed text-sm md:text-base">
                  Como rector de la institución,{" "}
                  {user?.first_name || "el usuario"} es el líder responsable de
                  supervisar todas las operaciones académicas y administrativas.
                  Su objetivo principal es garantizar que el entorno educativo
                  sea el más óptimo para el desarrollo y el aprendizaje de los
                  estudiantes.
                </p>

                <p className="text-gray leading-relaxed mt-4 text-sm md:text-base">
                  Con una visión clara y una sólida experiencia, el rector
                  trabaja estrechamente con profesores, padres de familia y el
                  equipo administrativo para implementar estrategias educativas
                  innovadoras, asegurar el cumplimiento de las normas y promover
                  el desarrollo integral de cada estudiante.
                </p>
              </div>
            )}

            <div className="mt-8 px-6">
              <CursosFooter />
            </div>

            {/* Historial de Pagos (Solo para Estudiantes) */}
            {user?.rol_id === 3 && (
              <div className="p-6 mt-6">
                <h3 className="text-xl font-semibold mb-4">
                  Historial de Pagos
                </h3>
                {pagos.length === 0 ? (
                  <p>No hay pagos registrados.</p>
                ) : (
                  <div className="overflow-hidden">
                    <table className="table-auto w-full border-collapse border border-gray-200">
                      <thead>
                        <tr className="bg-gray-100">
                          <th className="border border-gray-300 px-4 py-2 text-left">
                            # Pago
                          </th>
                          <th className="border border-gray-300 px-4 py-2 text-left">
                            Fecha
                          </th>
                          <th className="border border-gray-300 px-4 py-2 text-left">
                            Monto
                          </th>
                          <th className="border border-gray-300 px-4 py-2 text-left">
                            Razon Pago
                          </th>
                          <th className="border border-gray-300 px-4 py-2 text-left">
                            Estado
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {pagosActuales.map((pago) => (
                          <tr key={pago.pago_id}>
                            <td className="border border-gray-300 px-4 py-2">
                              #{pago.pago_id}
                            </td>
                            <td className="border border-gray-300 px-4 py-2">
                              {new Date(pago.fecha).toLocaleDateString("es-ES")}
                            </td>
                            <td className="border border-gray-300 px-4 py-2 font-bold">
                              ${pago.monto.toLocaleString()}
                            </td>
                            <td className="border border-gray-300 px-4 py-2 font-bold">
                              {pago.razon_pago.toLocaleString()}
                            </td>
                            <td className="border border-gray-300 px-4 py-2 text-green-600 font-semibold">
                              Hecho
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>

                    {/* Paginación */}
                    <div className="flex justify-end items-center mt-6 pr-4">
                      <button
                        onClick={() =>
                          setCurrentPage((prev) => Math.max(prev - 1, 1))
                        }
                        disabled={currentPage === 1}
                        className={`w-10 h-10 flex justify-center items-center rounded-full text-gray ${
                          currentPage === 1
                            ? "text-gray"
                            : "hover:bg-gray-200 hover:text-black"
                        }`}
                      >
                        ◀
                      </button>
                      {[...Array(totalPaginas).keys()].map((index) => (
                        <button
                          key={index}
                          onClick={() => setCurrentPage(index + 1)}
                          className={`w-10 h-10 mx-2 flex justify-center items-center border-2 border-gray text-gray rounded-full ${
                            currentPage === index + 1
                              ? "bg-main-blue text-white shadow-lg"
                              : "hover:bg-gray-200 hover:text-black hover:border-black"
                          }`}
                        >
                          {index + 1}
                        </button>
                      ))}
                      <button
                        onClick={() =>
                          setCurrentPage((prev) =>
                            Math.min(prev + 1, totalPaginas)
                          )
                        }
                        disabled={currentPage === totalPaginas}
                        className={`w-10 h-10 flex justify-center items-center rounded-full text-gray ${
                          currentPage === totalPaginas
                            ? "text-gray"
                            : "hover:bg-gray-200 hover:text-black"
                        }`}
                      >
                        ▶
                      </button>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>

          {/* Tarjetas de eventos */}
          <div className="mt-8 lg:mt-0 lg:ml-6">
            <Anuncio />
          </div>
        </div>
      </main>

      {/* Modal para mostrar información completa */}
      {modalData.isOpen && (
        <Modal
          isOpen={modalData.isOpen}
          onClose={handleCloseModal}
          title={modalData.title}
          content={modalData.content}
        />
      )}
    </div>
  );
};

export default DetallesPerfil;
